import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CustomerOnboardingFormComponent } from './customer-onboarding-form/customer-onboarding-form.component';
import { CustomerOnboadingEditFormComponent } from './customer-onboading-edit-form/customer-onboading-edit-form.component';

const routes: Routes = [
  {
    path: 'form',
    component: CustomerOnboardingFormComponent,
    data: {
      breadcrumb: 'Onboarding Form'
    }
  },
  {
    path: 'edit-customer-detail',
    component: CustomerOnboadingEditFormComponent,
    data: {
      breadcrumb: 'Edit Onboarding Details'
    }
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CustomerOnBoardingRoutingModule { }
